

function Login(props) {

    const updateUser = props.updateUser

    // const login = () => {
    //     updateUser(1);
    // }
    const login = (e) => {
        e.preventDefault();
        if (e.target[0].value=="krzwl"){
            updateUser(1);
        }
    }

    return (
        <div className="flex flex-col items-center">
            {/* <h2>Login Page</h2> */}
            <h1 className="font-Tsukimi text-[#ffee00] text-7xl shadow">mixbus</h1>
            <h4 className="flex m-auto">coming soon</h4>
            <form onSubmit={login} className="flex flex-col gap-1 mt-10">
                <input type="password" className="text-black rounded-md text-xs"></input><button className="text-black text-xs rounded-md bg-gray-300">ENTER</button>
            </form>
            {/* <button onClick={login}>login</button> */}
            {/* Login form elements would go here */}
        </div>
    );
}

export default Login;